export default __webpack_public_path__ + "static/media/susesi5.8817d8a8.jpg";